import config from 'config'
import { push } from 'connected-react-router'
import { PATHS } from 'constants.js'
import * as dateMenuSelectors from 'menu/DateMenu/selectors'
import { createLogic } from 'redux-logic'
import type { ReduxLogicState } from 'types/logic'
import { fetchAction } from 'utils'

import { setError, setIsProd, setRanges } from './actions'
import { FETCH_SYSTEM } from './constants'

const fetchSystem = createLogic({
  type: FETCH_SYSTEM,
  latest: true,

  async process({ getState }: ReduxLogicState, dispatch, done) {
    try {
      const baseRequestParams = dateMenuSelectors.baseRequestParams(getState())
      const { data } = await fetchAction(config.api.system, baseRequestParams)
      const {
        system: { isProd },
      } = getState()

      if (typeof data.isProd === 'boolean' && data.isProd !== isProd) {
        dispatch(setIsProd(data.isProd))
      }

      if (data?.ranges) {
        dispatch(setRanges(data.ranges))
      }

      if (data?.maintenanceTill) {
        dispatch(setError(data))
        dispatch(push(PATHS.ERROR))
      }
    } catch (error) {
      dispatch(
        setError({
          maintenanceMessage: error,
        }),
      )
      dispatch(push(PATHS.ERROR))
    }

    done()
  },
})

export default [fetchSystem]
